import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component
export default class ReferredCode extends Vue {
  @Action action_postReferencetWallet: any

  code = ''
  async _redeem () {
    try {
      const data = {
        reference: {
          code: this.code
        }
      }
      const res = await this.action_postReferencetWallet(data)
      this.$swal({
        imageUrl: '/assets/images/ui/cohete.png',
        imageWidth: 100,
        title: 'Referido',
        text: 'Haz sido referido por ' + res.data.referrer_user,
        showConfirmButton: false,
        timer: 3000
      })
    } catch (error) {
      this.$swal({
        title: error.response.data.message,
        showConfirmButton: false,
        timer: 3000
      })
      const status = error.response.status
      if (status >= 500) {
        this.$swal({
          title: 'Error al redimir código.',
          text: `Problemas con el servidor. Error ${status}`
        })
//        let message = 'Ayuda! \nMe está saliendo un error con el servidor.';
//        (window as any).Intercom('showNewMessage', message)
      } else {
        this.$swal({
          title: 'Error al redimir código.',
          text: error.response.data.message
        })
      }
    }
  }
}
